<template>
  <transition
    enter-active-class="ease-out duration-200"
    enter-class="opacity-0 scale-95"
    enter-to-class="opacity-100 scale-100"
    leave-active-class="ease-in duration-100"
    leave-class="opacity-100 scale-100"
    leave-to-class="opacity-0 scale-95"
  >
    <div v-show="show" class="absolute z-30 top-12 inset-x-0 transition transform origin-top-right md:hidden">
      <div class="shadow-lg">
        <div class="shadow-xs bg-white divide-y-2 divide-gray-50">
          <div class="pt-4 pb-6 px-5 space-y-4 sm:pb-8">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style></style>
